import { IAutoMapper } from "../interfaces";

export const mapDocumentPages = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "DocumentPages")
    .forMember("pages", o => automapper.mapMany("default", "DocumentPage", o.pages))
    .forMember("isCdnBucketFolderChecked", o => o.isCdnBucketFolderChecked)
    .forMember("s3ImagesFolders", o => o.s3ImagesFolders);
};
